import { FC } from 'react';
import { useWatch } from 'react-hook-form';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';
import { FormInput, Input } from '../../../components/input/index';
import { useReactForm } from '../../../hooks/index';
import { VaultSelect } from '../../../types/vault.types';
import { toUpperCaseWords } from '../../../utils/to-uppercase-util.util';
import { FormSchema, formSchema } from './create-modal';

export type RenameModalProps = {
  currentName?: string;
  folderNames?: string[];
  onClose: () => void;
  onSuccess: (name: string | undefined) => void;
  type: VaultSelect;
};

export const RenameModal: FC<RenameModalProps> = ({
  onClose,
  onSuccess,
  type,
  currentName,
  folderNames,
}) => {
  const { control } = useReactForm({
    schema: formSchema,
  });
  const { name } = useWatch<FormSchema>({ control });
  const { success } = formSchema.safeParse({ name });
  const isNameDuplicates = name ? folderNames?.includes(name?.toLowerCase()) : false;

  const isValid = success && !isNameDuplicates;

  const handleRename = () => {
    onSuccess(name);
  };
  return (
    <div className="m-2 flex w-full max-w-[493px] flex-col gap-8 rounded bg-white p-4">
      <div className="flex flex-col gap-4">
        <span className="text-xl font-semibold text-gray-700">
          {toUpperCaseWords(type)} <AppFormattedMessage id="RENAME" />
        </span>
        <Input
          disabled
          onChange={() => ''}
          placeholder={
            <AppFormattedMessage
              id="CURRENT_FILE_NAME"
              values={{
                text:
                  type === VaultSelect.FILE ? (
                    <AppFormattedMessage id="FILE" />
                  ) : (
                    <AppFormattedMessage id="FOLDER" />
                  ),
              }}
            />
          }
          value={currentName || ''}
          wrapperClassName={'transition-all duration-1000 w-full'}
        />
        <FormInput
          control={control}
          errorMessage={isNameDuplicates && `${name} already exists`}
          name={'name'}
          placeholder={
            <AppFormattedMessage
              id="NEW_FILE_NAME"
              values={{
                text:
                  type === VaultSelect.FILE ? (
                    <AppFormattedMessage id="FILE" />
                  ) : (
                    <AppFormattedMessage id="FOLDER" />
                  ),
              }}
            />
          }
          wrapperClassName={'transition-all duration-1000 w-full'}
        />
      </div>
      <div className="flex h-11 w-full justify-end gap-3">
        <Button
          className="h-full w-fit rounded border border-gray-300 px-6 py-[10px] text-sm font-[450] text-gray-700"
          onClick={onClose}
          styleType="NONE"
        >
          <AppFormattedMessage id="CANCEL" />
        </Button>
        <Button
          className="h-full w-fit bg-brand-700 px-6 py-[10px] text-sm font-[550] text-white"
          disabled={!isValid}
          onClick={handleRename}
          styleType="NONE"
        >
          <AppFormattedMessage id="DONE" />
        </Button>
      </div>
    </div>
  );
};
